import React from 'react';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

const Disclaimer = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    domainStore: { defaultDisclaimer },
  } = useRootStore();

  return (
    <>
      {defaultDisclaimer && (
        <div className={classes.disclaimer}>
          <h3 className={classes.disclaimerTitle}>Disclaimer:</h3>
          <p dangerouslySetInnerHTML={{ __html: defaultDisclaimer }} className={classes.disclaimerText} />
        </div>
      )}
    </>
  );
});

export default Disclaimer;
